<script setup lang="ts">
import type { SearchPanelProps } from '@/types/appTypes'

const props = withDefaults(defineProps<SearchPanelProps>(), {
  categories: () => ([]),
  tags: () => ([]),
  loading: false,
})

const app = useNuxtApp()
const route = useRoute()

const eventTermItems = [
  {
    text: 'すべて',
    value: null,
  },
  {
    text: '開催中',
    value: 'in',
  },
  {
    text: 'もうすぐ開催',
    value: 'start',
  },
  {
    text: 'もうすぐ終了',
    value: 'end',
  },
]

const data = reactive({
  textTerm: '',
  modelEventCalender: null,
  modelMenuStartDate: false,
  modelQuery: {} as any,
})

const updateTerm = () => {
  if (data.modelQuery.term) {
    for (let i = 0; i < eventTermItems.length; i++) {
      if (data.modelQuery.term === eventTermItems[i].value) {
        data.textTerm = eventTermItems[i].text
        break
      }
    }
    if (!data.textTerm && useDayjs(data.modelQuery.term).isValid()) {
      data.textTerm = data.modelQuery.term
      data.modelEventCalender = new Date(data.modelQuery.term)
    }
  } else {
    data.textTerm = ''
  }
}

const onClickTermItem = (item) => {
  data.modelEventCalender = null
  data.textTerm = item.text
  data.modelQuery.term = item.value
  data.modelMenuStartDate = false
}

const onUpdateCalender = (value) => {
  data.modelMenuStartDate = false
  const selDate = useDayjs(value).format('YYYY-MM-DD')
  data.modelQuery.term = selDate
  data.textTerm = selDate
}

const onUpdateCalenderJyunkai = () => {
  data.modelMenuStartDate = false
  const selDate = useDayjs(data.modelEventCalender).format('YYYY-MM-DD')
  data.modelQuery.term = selDate
  data.textTerm = selDate
}

const onSearch = () => {
  console.log('onSearch', data.modelQuery)

  const params = { ...data.modelQuery }
  const notNullParam = {} as any

  for (const key in params) {
    if (!(params[key] === null || params[key] === '')) {
      if (Array.isArray(params[key])) {
        if (params[key].length) {
          notNullParam[key] = params[key].join(',')
        }
      } else {
        notNullParam[key] = params[key]
      }
    }
  }
  if ('page' in notNullParam) {
    delete notNullParam.page
  }

  if ('sort' in route.query) {
    notNullParam.sort = route.query.sort
  }

  if (params.term) {
    const term = params.term
    if (term === 'in') {
      notNullParam.sort = 'open_date'
    } else if (term === 'end') {
      notNullParam.sort = 'term_to'
    } else if (term === 'start') {
      notNullParam.sort = 'term_from'
    } else if (term) {
      notNullParam.sort = 'open_date'
    }
  }

  navigateTo({
    path: route.path,
    query: notNullParam,
  })
}

const onKeyEnter = (event) => {
  if (event.keyCode !== 13) {
    return
  }
  onSearch()
}

const queryToNumberArray = (queryValue: string): any[] => {
  const aVal = queryValue.split(',').map(item => Number(item))
  return aVal
}

data.modelQuery = { ...props.query }
if (data.modelQuery.tag) {
  data.modelQuery.tag = queryToNumberArray(data.modelQuery.tag)
}
if (data.modelQuery.cat) {
  data.modelQuery.cat = queryToNumberArray(data.modelQuery.cat)
}
if (data.modelQuery.equip) {
  data.modelQuery.equip = queryToNumberArray(data.modelQuery.equip)
}

updateTerm()
</script>

<template>
  <div class="p-searchPanel">
    <template
      v-if="articleName === 'museum'"
    >
      <div class="p-searchPanel_row">
        <div class="p-searchPanel_item w25">
          <SelectArea
            v-model="data.modelQuery.area"
          />
        </div>
        <div class="p-searchPanel_item w25">
          <v-select
            v-model="data.modelQuery.cat"
            class="c-searchControl"
            v-bind:items="app.$getChildCategoriesBySlug(categories, 'root_kind')"
            label="館種"
            item-title="name"
            item-value="id"
            multiple
            hide-details
            variant="underlined"
            density="comfortable"
            single-line
          />
        </div>
        <div class="p-searchPanel_item w25">
          <v-select
            v-model="data.modelQuery.equip"
            class="c-searchControl"
            v-bind:items="app.$getChildCategoriesBySlug(categories, 'root_option')"
            label="設備"
            item-title="name"
            item-value="id"
            multiple
            variant="underlined"
            counter
            density="comfortable"
            single-line
            hide-details
          />
        </div>
        <div class="p-searchPanel_item w25">
          <v-select
            v-model="data.modelQuery.tag"
            class="c-searchControl"
            v-bind:items="tags"
            label="ジャンル"
            item-title="name"
            item-value="id"
            multiple
            single-line
            hide-details
            variant="underlined"
            density="comfortable"
          />
        </div>
      </div>
      <div class="p-searchPanel_row">
        <div class="p-searchPanel_item">
          <v-text-field
            v-model="data.modelQuery.search"
            label="館名"
            variant="outlined"
            bg-color="#fff"
            color="primary"
            v-on:keyup.enter="onKeyEnter"
          />
        </div>
        <div class="p-searchPanel_submit">
          <v-btn
            tile
            variant="flat"
            color="primary"
            v-bind:disabled="loading"
            v-on:click="onSearch"
          >
            <v-icon>
              mdi-magnify
            </v-icon>探す
          </v-btn>
        </div>
      </div>
    </template>

    <template
      v-if="articleName === 'event'"
    >
      <div class="p-searchPanel_row">
        <div class="p-searchPanel_item w25">
          <SelectArea
            v-model="data.modelQuery.area"
          />
        </div>
        <div class="p-searchPanel_item w25">
          <v-select
            v-model="data.modelQuery.event"
            class="c-searchControl"
            v-bind:items="[
              { title: 'すべて', value: null },
              { title: '展覧会', value: '0' },
              { title: 'イベント', value: '1' },
            ]"
            label="種類"
            hide-details
            single-line
            variant="underlined"
            density="comfortable"
          />
        </div>
        <div class="p-searchPanel_item w25">
          <v-menu
            v-model="data.modelMenuStartDate"
            v-bind:close-on-content-click="false"
            transition="slide-y-transition"
            min-width="290px"
          >
            <template v-slot:activator="activator">
              <v-text-field
                v-model="data.textTerm"
                class="c-searchControl"
                v-bind:append-icon="data.modelMenuStartDate ? 'mdi-menu-up': 'mdi-menu-down'"
                label="開催日"
                placeholder="開催日"
                hide-details
                readonly
                variant="underlined"
                density="comfortable"
                single-line
                v-bind="activator.props"
              />
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in eventTermItems"
                v-bind:key="index"
                ripple
                link
                flat
                v-on:click="onClickTermItem(item)"
              >
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
            <div
              class="c-searchControl_selectItemLabel"
            >
              日付を指定
            </div>
            <v-date-picker
              v-model="data.modelEventCalender"
              hide-header
              v-on:update:model-value="onUpdateCalender"
            />
          </v-menu>
        </div>
        <div class="p-searchPanel_item w25">
          <v-select
            v-model="data.modelQuery.tag"
            class="c-searchControl"
            v-bind:items="tags"
            label="ジャンル"
            placeholder="ジャンル"
            item-title="name"
            item-value="id"
            multiple
            hide-details
            single-line
            variant="underlined"
            density="comfortable"
          />
        </div>
      </div>
      <div class="p-searchPanel_row">
        <div class="p-searchPanel_item">
          <v-text-field
            v-model="data.modelQuery.search"
            label="展覧会名"
            variant="outlined"
            hide-details
            bg-color="#fff"
            color="primary"
            v-on:keyup.enter="onKeyEnter"
          />
        </div>
        <div class="p-searchPanel_submit">
          <v-btn
            tile
            variant="flat"
            color="primary"
            v-bind:disabled="loading"
            v-on:click="onSearch"
          >
            <v-icon>
              mdi-magnify
            </v-icon>探す
          </v-btn>
        </div>
      </div>
    </template>

    <template
      v-if="articleName === 'jyunkai'"
    >
      <div class="p-searchPanel_row">
        <div class="p-searchPanel_item w50">
          <SelectArea
            v-model="data.modelQuery.area"
          />
        </div>
        <div class="p-searchPanel_item w50">
          <v-menu
            v-model="data.modelMenuStartDate"
            v-bind:close-on-content-click="false"
            transition="slide-y-transition"
            min-width="290px"
          >
            <template v-slot:activator="activator">
              <v-text-field
                v-model="data.textTerm"
                class="c-searchControl is-calender"
                v-bind:append-icon="data.modelMenuStartDate ? 'mdi-menu-up': 'mdi-menu-down'"
                label="開催日"
                placeholder="開催日"
                single-line
                clearable
                hide-details
                readonly
                variant="underlined"
                density="comfortable"
                v-bind="activator.props"
                v-on:click:clear="data.modelQuery.term = null; data.textTerm = ''; data.modelEventCalender = null"
              />
            </template>
            <v-date-picker
              v-model="data.modelEventCalender"
              hide-header
              v-on:input="data.modelMenuStartDate = false"
              v-on:update:model-value="onUpdateCalenderJyunkai"
            />
          </v-menu>
        </div>
      </div>
      <div class="p-searchPanel_row">
        <div class="p-searchPanel_item">
          <v-text-field
            v-model="data.modelQuery.search"
            label="フリーワード"
            variant="outlined"
            hide-details
            bg-color="#fff"
            v-on:keyup.enter="onKeyEnter"
          />
        </div>
        <div class="p-searchPanel_submit">
          <v-btn
            tile
            variant="flat"
            color="primary"
            v-bind:disabled="loading"
            v-on:click="onSearch"
          >
            <v-icon>
              mdi-magnify
            </v-icon>探す
          </v-btn>
        </div>
      </div>
    </template>

    <template
      v-if="articleName === 'royal-family'"
    >
      <div class="p-searchPanel_row nowrap">
        <div class="p-searchPanel_item">
          <v-select
            v-model="data.modelQuery.cat"
            class="c-searchControl"
            v-bind:items="categories"
            item-title="name"
            item-value="id"
            label="年"
            single-line
            hide-details
          />
        </div>
        <div class="p-searchPanel_submit">
          <v-btn
            variant="tonal"
            color="primary"
            v-bind:disabled="loading"
            v-on:click="onSearch"
          >
            <v-icon>
              mdi-magnify
            </v-icon>探す
          </v-btn>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.p-searchPanel {
  margin-top: 24px;
  padding: 0 10px 19px;
  border-width: 1px;
  border-style: solid;
  border-color: #014da3;
  background-color: #f1f4f6;

  &_row {
    display: flex;
    flex-wrap: wrap;

    &.nowrap {
      flex-wrap: nowrap;

      @include responsive.mq_down(sp) {
        flex-wrap: wrap;
      }
    }
  }

  &_item {
    flex-grow: 1;
    min-width: 25%;
    margin: 17px 0 5px;
    padding: 0 10px;

    &.w25 {
      width: 25%;

      @include responsive.mq_down(sp) {
        width: 50%;
      }
    }

    &.w50 {
      width: 50%;
    }

    @include responsive.mq_down(sp) {
      width: 50%;
    }
  }

  &_submit {
    flex-shrink: 0;
    margin: 17px 0 5px;
    padding: 0 10px;
    text-align: center;

    @include responsive.mq_down(sp) {
      min-width: 100%;
    }

    .v-btn {
      width: 200px;
      height: 50px !important;

      @include responsive.mq_down(sp) {
        margin-top: 4px;
      }
    }
  }
}

.c-searchControl {
  &_selectItemLabel {
    padding: 8px 16px;
    background-color: var(--g_color_border_gray);
    font-size: 16px;
  }

  &:deep(.v-text-field) {
    margin-top: 0;
    padding-top: 0;

    .v-input__prepend-inner,
    .v-input__append-inner {
      top: 4px;
    }

    .v-label {
      top: 8px;
      color: #626262;
    }
  }

  &:deep(.v-input) {
    input {
      height: 37px;
      max-height: 37px;
      color: #000 !important;
    }
  }

  &:deep(.v-input__append-inner) {
    position: absolute;
    right: 0;
    pointer-events: none;
  }

  :deep(.v-field__input) {
    flex-wrap: nowrap;
    min-height: 37px;
  }

  :deep(.v-select__selection) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  :deep(.v-chip) {
    display: block;
    max-width: 90%;
    height: auto;
    margin: 7px 4px 7px 0;
    padding: 0;
    overflow: hidden;
    border-radius: 0;
    background-color: transparent;
    font-size: 16px;
    line-height: 18px;
    pointer-events: none;

    .v-chip__content {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.c-searchControl.is-calender {
  &:deep(.v-input) {
    input {
      cursor: pointer;
    }
  }

  &:deep(.v-input__icon--clear) {
    position: absolute;
    right: 24px;
    pointer-events: auto;
  }
}
</style>
